import { Button } from "@mantine/core";
import { ISummaryItem } from "src/pages/Summary/Summary.types";

interface Props {
  items: ISummaryItem[];
  itemsLength?: number;
  setItems: (items: any) => void;
}

const ClearSelectionsButton = ({ setItems, items, itemsLength }: Props) => {
  return (
    (itemsLength !== undefined ? itemsLength > 0 : true) && (
      <Button variant="outline" onClick={() => setItems(items)}>
        Clear selections
      </Button>
    )
  );
};
export default ClearSelectionsButton;
